import axios from 'axios';
import { API_URL, API_ENDPOINTS } from '../../../constants/api';
import type { MatchHubApiResponse, RawApiFixture, RawApiLineup, RawApiEvent } from './matchHubData.helper';
import type { MatchHubFormResult, MatchHubTeamFacts, MatchHubRecentRecord } from '../types/matchHub.types';

export interface RawTeamInsights {
  form?: Array<{ result: MatchHubFormResult; opponent: string; score: string; date: string }>;
  record?: MatchHubRecentRecord;
  facts?: MatchHubTeamFacts | null;
}

export interface RawMatchInsights {
  home: RawTeamInsights;
  away: RawTeamInsights;
}

export async function fetchMatchHubData(matchId: string): Promise<MatchHubApiResponse> {
  const url = `${API_URL}${API_ENDPOINTS.matches.match(matchId)}`;
  const { data } = await axios.get<{ success: boolean; data: MatchHubApiResponse }>(url);
  return data.data;
}

export async function fetchMatchH2HRaw(
  matchId: string,
): Promise<{ fixtures: RawApiFixture[] } | null> {
  try {
    const url = `${API_URL}${API_ENDPOINTS.matches.h2h(matchId)}`;
    const { data } = await axios.get<{ success: boolean; data: { fixtures: RawApiFixture[] } }>(url);
    return data?.data ?? null;
  } catch {
    return null;
  }
}

export async function fetchMatchLineupsRaw(
  matchId: string,
): Promise<{ lineups: RawApiLineup[] | null } | null> {
  try {
    const url = `${API_URL}${API_ENDPOINTS.matches.lineups(matchId)}`;
    const { data } = await axios.get<{ success: boolean; data: { lineups: RawApiLineup[] | null } }>(url);
    return data?.data ?? null;
  } catch {
    return null;
  }
}

export async function fetchMatchEventsRaw(
  matchId: string,
): Promise<{ events: RawApiEvent[] } | null> {
  try {
    const url = `${API_URL}${API_ENDPOINTS.matches.events(matchId)}`;
    const { data } = await axios.get<{ success: boolean; data: { events: RawApiEvent[] } }>(url);
    return data?.data ?? null;
  } catch {
    return null;
  }
}

export async function fetchMatchInsightsRaw(matchId: string): Promise<RawMatchInsights | null> {
  try {
    const url = `${API_URL}${API_ENDPOINTS.matches.insights(matchId)}`;
    const { data } = await axios.get<{ success: boolean; data: RawMatchInsights }>(url);
    return data?.data ?? null;
  } catch {
    return null;
  }
}
